import { Directive } from '@angular/core';

@Directive({
  selector: '[pxc-form-grid-section-cell]',
  host: {
    class: 'py-2! bg-background-secondary!',
  },
})
export class FormGridSectionCellDirective {}
